import { render } from "./DeclencheurAudienceSetup.vue?vue&type=template&id=07ca63da&scoped=true"
import script from "./DeclencheurAudienceSetup.vue?vue&type=script&lang=ts"
export * from "./DeclencheurAudienceSetup.vue?vue&type=script&lang=ts"

import "./DeclencheurAudienceSetup.vue?vue&type=style&index=0&id=07ca63da&lang=scss&scoped=true"
import "./DeclencheurAudienceSetup.vue?vue&type=style&index=1&id=07ca63da&lang=scss"
script.render = render
script.__scopeId = "data-v-07ca63da"

export default script